












import { Component, Vue } from 'vue-property-decorator'
import GetExternalLinkFileApi from '@/app/model/api/getExternalLinkFileApi'
import ExternalLinkContentDetailApi from '@/app/model/api/externalLinkContentDetailApi'
import CommonClass from '@/app/module/common'
import { routerPath, errorFlag, common } from '@/app/model/store/domain/const'
import { MetaInfo } from 'vue-meta'
import PdfPreview from '@/app/components/Common/PdfPreview.vue'

@Component({
  components: {
    PdfPreview
  },
  metaInfo (this: ExternalLinkPdfPreview): MetaInfo {
    return {
      title: this.setPageTitle
    }
  }
})

export default class ExternalLinkPdfPreview extends Vue {
  private externalLinkName: string = ''
  private externalLinkContentName: string = ''
  private blobPath: any = {}
  private pageTitle = ''

  private get setPageTitle () {
    return this.pageTitle
  }

  created () {
    this.getExternalLinkDetail()
  }

  destroy () {
    URL.revokeObjectURL(this.blobPath as string)
  }

  private getExternalLinkDetail () {
    (async () => {
      const result = await ExternalLinkContentDetailApi.getDetail(this.$route.params.external_link_content_id)
      if (result.isOk()) {
        const payload = result.getPayload()
        this.externalLinkName = payload.external_link.external_link_name
        this.externalLinkContentName = payload.external_link_content.content_name
        this.pageTitle = this.externalLinkName + '_' + this.externalLinkContentName + ' | ' + common.SYSTEM_NAME

        // 取得した外部連携IDと、URLの外部連携IDが一致している かつ ファイルがあるか確認
        if (payload.external_link.external_link_id === Number(this.$route.params.external_link_id) && payload.external_link_content.content_file !== '') {
          // PDF情報を取得するIDを設定
          this.getExternalLinkFile(Number(this.$route.params.external_link_content_id))
        } else {
          // 存在しない場合は404遷移
          this.$store.commit('routeState/setErrorFlag', errorFlag.ERROR_FLAG_DEFAULT)
          this.$router.push(routerPath.PATH_ERROR_PAGE).catch(e => {})
        }
      } else {
        // 200以外の場合はerrorページ遷移
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
    })()
  }

  private async getExternalLinkFile (id: number) {
    const result = await GetExternalLinkFileApi.getExternalLinkFile(id)

    if (typeof result === 'string') {
      this.blobPath = result
    } else {
      const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
    }
  }
}
